import { Directive, Host, HostListener } from "@angular/core";
import { LoggingService } from "../../logging.service";
import { IUiLoggerPayload } from "../../logging.model";

@Directive({
  selector: 'canvas'
})
export class MouseDirective {
  constructor(
    private logger: LoggingService
  ) {
  }

  private createInitialPayload(event: Event, context: string) {
    const target = event.target as HTMLCanvasElement;
    const tag = target.tagName?.toLowerCase();
    const text = target.textContent || target.getAttribute('placeholder') || 'Unknown Field';
    const id = target.id || undefined;
    const classes = target.className || undefined;
    return {
      context: context,
      element: target,
      tag,
      text,
      id,
      classes,
    };
}

  @HostListener('pointerup', ['$event'])
  onMouseUp(event: Event) {
    const payload = this.createInitialPayload(event, "MouseUp");
    this.logger.logUi(payload);
  }

  @HostListener('mousedown', ['$event'])
  onMouseDown(event: Event) {
    const payload = this.createInitialPayload(event, "MouseDown");
    this.logger.logUi(payload);
  }

  @HostListener('mousewheel', ['$event'])
  onMouseWheel(event: Event) {
    const payload = this.createInitialPayload(event, "MouseWheel");
    this.logger.logUi(payload);
  }

  @HostListener('doubleclick', ['$event'])
  onDoubleClick(event: Event) {
    const payload = this.createInitialPayload(event, "DoubleClick");
    this.logger.logUi(payload);
  }

  /**
   * internal function to log the click event.
   * @param element clickable element information
   */
  protected logUi(element: IUiLoggerPayload) {
    this.logger.logUi(element);
  }
}
